import { FC, useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import ErrorTemplate from '@/components/templates/Error';
import MultiraceResultTemplate from '@/components/templates/Velodrome/Result/Multirace';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import {
  MultiraceProgram,
  RaceProgram,
  useGetMultiraceResultQuery,
} from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';
import { VelodromeRoutesProps } from '@/routes/Velodrome';
import { toHalfWidth } from '@/utility/utils';

const SingleraceResultPage: FC<VelodromeRoutesProps> = ({ velodrome }) => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  const { heldDate } = useParams<{
    heldDate: string;
  }>();

  const input = {
    velodromeCode: velodrome.code,
    heldDate: dayjst(heldDate),
  };

  const multiraceResultQuery = useGetMultiraceResultQuery({
    variables: {
      raceProgramInput: input,
      multiraceProgramsInput: input,
    },
  });

  useEffect(() => {
    if (!multiraceResultQuery.data) {
      return;
    }
    setBreadcrumbs([
      {
        name: `${velodrome.name}競輪`,
        to: `/${velodrome.romanName}`,
      },
      {
        name: toHalfWidth(
          `${
            multiraceResultQuery.data.raceProgram.programName ||
            `${velodrome.name}競輪 ${multiraceResultQuery.data.raceProgram.gradeName}`
          }（${multiraceResultQuery.data.raceProgram.heldDate.format(
            'YYYY年M月D日',
          )}）`,
        ),
        to: '',
      },
    ]);
  }, [multiraceResultQuery.data]);

  const title = `${velodrome.name}競輪 ${toHalfWidth(
    multiraceResultQuery.data
      ? multiraceResultQuery.data.raceProgram.programName
      : '',
  )}（${dayjst(heldDate).format('YYYY年M月D日')}）チャリロト・Dokanto!結果`;

  const description = `${velodrome.name}競輪 ${toHalfWidth(
    multiraceResultQuery.data
      ? multiraceResultQuery.data.raceProgram.programName
      : '',
  )}のチャリロト・Dokanto!結果です。`;

  return (
    <>
      <Helmet
        meta={{
          title,
          description: `${description}%s`,
          keywords: `${title},%s`,
        }}
      />
      {multiraceResultQuery.error ? (
        <ErrorTemplate apolloError={multiraceResultQuery.error} />
      ) : (
        <>
          {multiraceResultQuery.data && (
            <MultiraceResultTemplate
              multiracePrograms={
                multiraceResultQuery.data
                  .multiracePrograms as MultiraceProgram[]
              }
              raceProgram={multiraceResultQuery.data.raceProgram as RaceProgram}
            />
          )}
        </>
      )}
    </>
  );
};
export default SingleraceResultPage;
